import { findAndReplace } from '../../../utils/arrayModify';

export function handleUpdateStateWithDeleteDoc(state, action) {
  const targetAppointment = state.list.find(
    ({ id }) => action.payload.appointmentId === id,
  );

  if (targetAppointment) {
    const targetDocument = targetAppointment.documents.findIndex(
      ({ id }) => action.payload.documentId === id,
    );
    targetAppointment.documents.splice(targetDocument, 1);

    return {
      ...state,
      list: findAndReplace(state.list, {
        ...targetAppointment,
      }),
    };
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/components/Healthboard/utils/handleUpdateStateWithDeleteDoc.js